module.exports = __webpack_public_path__ + "static/film-11ead6224f8098a9ceb97edc73d555fe.mp4";